import {SingleSelectGridPickerDialog} from './SingleSelectGridPickerDialog';

// BE single-select employee picker datagrid (T20-128011 / MR !13909); row id = employee id.
const EMPLOYEE_PICKER_GRID_CODE = 'record-audit-pair-employee-single';

interface RecordAuditEmployeePickerDialogProps {
  onConfirm: (employeeId: string) => void;
  // When set, renders a leading "clear" action (used by the optional responsible person).
  onClear?: () => void;
}

/**
 * Single-select employee picker backed by the BE `record-audit-pair-employee-single` datagrid
 * (auditor / responsible person). The grid row id is the employee UUID, so the confirmed selection
 * emits an employee id directly.
 */
export function RecordAuditEmployeePickerDialog(props: RecordAuditEmployeePickerDialogProps) {
  return (
    <SingleSelectGridPickerDialog
      gridCode={EMPLOYEE_PICKER_GRID_CODE}
      onConfirm={props.onConfirm}
      onClear={props.onClear}
      data-testid="recordAuditEmployeePicker"
    />
  );
}
